"use strict";
/* THIS IS A GENERATED FILE */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkubanaInventoryApiClient = void 0;
const BaseApiClient_1 = require("./BaseApiClient");
class SkubanaInventoryApiClient extends BaseApiClient_1.BaseApiClient {
    async createProductStocks(putInventoryList, queryParams) {
        const path = `/v1.1/inventory`;
        return await this.request("put", path, queryParams, putInventoryList);
    }
    async addProductStockQuantity(postInventoryAdd) {
        const path = `/v1.1/inventory/add`;
        return await this.request("post", path, undefined, postInventoryAdd);
    }
    async updateProductStockQuantities(postInventoryAdjust) {
        const path = `/v1.1/inventory/adjust`;
        return await this.request("post", path, undefined, postInventoryAdjust);
    }
    async removeProductStockQuantity(postInventoryRemove) {
        const path = `/v1.1/inventory/remove`;
        return await this.request("post", path, undefined, postInventoryRemove);
    }
    async retrieveProductStockTotals(queryParams) {
        const path = `/v1.1/productstocks/total`;
        return await this.request("get", path, queryParams, undefined);
    }
    async updateStockLocationAttributes(postInventoryDto) {
        const path = `/v1.2/inventory`;
        return await this.request("post", path, undefined, postInventoryDto);
    }
    async retrieveInventoryUpdates(queryParams) {
        const path = `/v1.2/inventory/acknowledge`;
        return await this.request("post", path, queryParams, undefined);
    }
    async retrieveProductStocks(queryParams) {
        const path = `/v1/inventory`;
        return await this.request("get", path, queryParams, undefined);
    }
    async retrieveFbaInventory(queryParams) {
        const path = `/v1/inventory/fba`;
        return await this.request("get", path, queryParams, undefined);
    }
    async retrieveProductStockHistory(queryParams) {
        const path = `/v1/inventory/history`;
        return await this.request("get", path, queryParams, undefined);
    }
    async markStockAsPicked(queryParams) {
        const path = `/v1/inventory/pick`;
        return await this.request("post", path, queryParams, undefined);
    }
    async retrievePicklist(queryParams) {
        const path = `/v1/inventory/picklist`;
        return await this.request("get", path, queryParams, undefined);
    }
    async transferProductStocks(queryParams) {
        const path = `/v1/inventory/transfer`;
        return await this.request("post", path, queryParams, undefined);
    }
    async retrieveProductStockTotals2(queryParams) {
        const path = `/v1/productstocks/total`;
        return await this.request("get", path, queryParams, undefined);
    }
}
exports.SkubanaInventoryApiClient = SkubanaInventoryApiClient;
